<template>
	<div class="brick">
		<div class="list_top_box">
			<p class="mgb_5">
				<em class="lt_text">Work Start Date</em>
				<span class="mgr_10"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<em class="lt_text">Type</em>
				<span class="int_type_no_border int_type mgr_10">
					<!-- <AC :initialDisplay="keyword" :initialValue="wh_staff_id" :source="wh_staff_list" @nothingSelected="clearAC" @clear="clearAC" v-model="wh_staff_id" results-display="name" results-value="user_id" placeholder="NAME" :key="acKey" /> -->
					<select v-model="type">
						<option :value="null">ALL</option>
						<option value="PACKER">Packer</option>
						<option value="PICKER">Picker</option>
					</select>
				</span>

				<em class="lt_text">W/H Staff</em>
				<span class="int_type_no_border int_type mgr_10">
					<!-- <AC :initialDisplay="keyword" :initialValue="wh_staff_id" :source="wh_staff_list" @nothingSelected="clearAC" @clear="clearAC" v-model="wh_staff_id" results-display="name" results-value="user_id" placeholder="NAME" :key="acKey" /> -->
					<select v-model="wh_staff_id">
						<option :value="null">ALL</option>
						<option disabled>-----------------------------------</option>
						<option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.user_id">{{ staff.name }}</option>
					</select>
				</span>

				<em class="lt_text">Sales Order / Sample No </em>
				<span class="int_type_no_border int_type sm_int mgr_10">
					<input type="text" v-model.trim="so_keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="getPackingPerStaff" />
				</span>

				<em class="lt_text mgr_5">
					Box Type
				</em>
				<span class="int_type mgr_15">
					<select v-model="box_type" class="tbl_select sm_int">
						<option v-for="(bt, index) in box_type_list" :key="index" :value="bt.value">{{ bt.display }}</option>
					</select>
				</span>

				<span class="mgr_10">
					<a href="javascript:;" class="search_bt mgr_5" @click="getPackingPerStaff">Search</a>
					<a href="javascript:;" class="gray_bt mgr_5" @click="reset">Reset</a>
				</span>

				<template v-if="!component_of_modal && isGraphInfo && isPackingPerStaffInfo">
					<span class="mgr_5">
						<a href="javascript:void(0);" class="gray_bt" v-on:click="showGraph">{{ isShowGraph ? 'Hide Graph' : 'Show Graph' }}</a>
					</span>
					<span class="mgr_5"><a href="javascript:void(0);" class="gray_bt" v-on:click="reportPrint">Print</a></span>
				</template>
			</p>
			<p v-if="component_of_modal">
				<span class="mgr_15">
					<PartnerSelect v-model.trim="ship_to_code" ph="Ship To" />
				</span>
				<span class="mgr_5">
					<PartnerSelect v-model.trim="bill_to_code" ph="Bill To" />
				</span>
			</p>
		</div>
		<div v-if="isGraphInfo && isPackingPerStaffInfo && isShowGraph && !component_of_modal">
			<table>
				<tr>
					<td rowspan="2" style="width: 70%;">
						<div style="overflow: hidden; min-height: 420px; max-height: 420px; position: relative; padding-left: 20px;">
							<WarehouseWorking :graph_datasets="graph_datasets" :key="chartKey" :is_graph_image="is_graph_image" @printGraphImage="printGraphImage" />
						</div>
					</td>
					<td>
						<div class="mgl_15">
							<div class="mgb_20">
								<b>Graph Sort by: </b>
								<label class="mgr_10"><input type="radio" v-model="graph_sort" value="QTY" @change="setNSortGraphDatasets(graph_datasets)" /> QTY</label>
								<label class="mgr_10"><input type="radio" v-model="graph_sort" value="TIME" @change="setNSortGraphDatasets(graph_datasets)" /> AvgPCS(1HOUR)</label>

								<a href="javascript:void(0);" class="gray_bt" v-on:click="is_graph_image = true">PrintGraph</a>
							</div>

							<table class="td_bold mgb_20" style="width: 50%;">
								<colgroup>
									<col style="width: 50%;" />
									<col style="width: 50%;" />
								</colgroup>
								<tr>
									<td>INV.AMOUNT($):</td>
									<td class="al_right">{{ inv_info.net_sales_amount | toCurrency }}</td>
								</tr>
								<tr>
									<td>INV.COUNT:</td>
									<td class="al_right">{{ inv_info.invoice_cnt | commaSeparated }}</td>
								</tr>
								<tr>
									<td>INV.PCS:</td>
									<td class="al_right">{{ inv_info.shipped_quantity | commaSeparated }}</td>
								</tr>
							</table>

							<table class="td_bold" style="width: 75%;">
								<colgroup>
									<col style="width: 50%;" />
									<col style="width: 25%;" />
									<col style="width: 25%;" />
								</colgroup>
								<tr v-if="!search_type">
									<td></td>
									<td v-if="!search_type || search_type === 'PICKER'" class="al_right">PICKER</td>
									<td v-if="!search_type || search_type === 'PACKER'" class="al_right">PACKER</td>
								</tr>
								<tr>
									<td>Total PCS:</td>
									<td v-if="!search_type || search_type === 'PICKER'" class="al_right">{{ agg_info.sum_picker_pcs | commaSeparated }}</td>
									<td v-if="!search_type || search_type === 'PACKER'" class="al_right">{{ agg_info.sum_packer_pcs | commaSeparated }}</td>
								</tr>
								<tr>
									<td>Avg PCS:</td>
									<td v-if="!search_type || search_type === 'PICKER'" class="al_right">{{ agg_info.avg_picker_pcs | toCurrency }}</td>
									<td v-if="!search_type || search_type === 'PACKER'" class="al_right">{{ agg_info.avg_packer_pcs | toCurrency }}</td>
								</tr>
								<tr>
									<td>Avg PCS(for an Hour):</td>
									<td v-if="!search_type || search_type === 'PICKER'" class="al_right">{{ agg_info.avg_picking_pcs_per_hour | toCurrency }}</td>
									<td v-if="!search_type || search_type === 'PACKER'" class="al_right">{{ agg_info.avg_packing_pcs_per_hour | toCurrency }}</td>
								</tr>
								<tr>
									<td>Avg Time(per S/O):</td>
									<td v-if="!search_type || search_type === 'PICKER'" class="al_right">{{ agg_info.avg_picker_invoice_time | toCurrency }} m</td>
									<td v-if="!search_type || search_type === 'PACKER'" class="al_right">{{ agg_info.avg_packer_invoice_time | toCurrency }} m</td>
								</tr>
							</table>
						</div>
					</td>
				</tr>
			</table>
		</div>

		<div :class="{ 'fixed-table-container-none-padding': component_of_modal }">
			<div class="mgb_20" :class="{ 'table-wrapper': component_of_modal }" :style="{ height: component_of_modal ? '95%' : undefined }">
				<table class="list_tbl" :class="{ sticky_list_tbl: component_of_modal }">
					<thead>
						<tr>
							<th>Name(ID)</th>
							<th style="width: 6%;">Date</th>
							<th style="width: 4%;">Type</th>
							<th style="width: 5%;">ACCT</th>
							<th style="width: 7%;">
								<a href="javascript: void(0)" @click="sort('SN')">SN{{ sortMark('SN') }}</a>
							</th>
							<th style="width: 7%;">BN</th>
							<th style="width: 8%;">Status</th>
							<th style="width: 3%;">D's</th>
							<th style="width: 7%;">
								<a href="javascript: void(0)" @click="sort('time_in')">Time In{{ sortMark('time_in') }}</a>
							</th>
							<th style="width: 7%;">
								<a href="javascript: void(0)" @click="sort('time_out')">Time Out{{ sortMark('time_out') }}</a>
							</th>
							<th style="width: 5%;">Duration</th>
							<th style="width: 4%;">box<br />Qty</th>
							<th style="width: 4%;">Ord.<br />Qty</th>
							<th style="width: 4%;">Work<br />Qty</th>
							<th style="width: 4%;" v-if="!search_box_type">Whole<br />box</th>
							<th style="width: 4%;">PCS<br />(day)</th>
							<th style="width: 4%;">PCS<br />(total)</th>
							<th style="width: 5%;">Avg<br />Time</th>
							<th style="width: 4%;">AvgPCS<br />(1HOUR)</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(el, index) in packing_per_staff_list">
							<template v-if="el.order_list">
								<tr class="normal_tbl" v-for="(order, jIndex) in el.order_list" :key="index + '/' + jIndex">
									<td v-if="jIndex === 0 && el.rowspanCnt" :rowspan="el.rowspanCnt">{{ el.name }}<br />({{ el.user_id }})</td>
									<td v-if="jIndex === 0" :rowspan="el.order_list.length">{{ el.date }}</td>
									<td v-if="jIndex === 0" :rowspan="el.order_list.length">{{ el.type }}</td>
									<td>
										<a href="javascript: void(0);" @click="goToBoxing(order.so_dn)">{{ order.bill_to_code }}</a>
									</td>
									<td>
										<a href="javascript: void(0);" @click="printPicking(order)">
											<font :color="order.urgent_yn == 'Y' ? 'red' : 'black'">{{ order.so_dn }}</font>
										</a>
									</td>
									<td>{{ order.invoice_dn }}</td>
									<td>
										<span v-if="order.status_code === 'X'" :style="{ color: order.color_by_status }">Sample</span>
										<span v-else :style="{ color: order.color_by_status }">{{ order.status_code | saleStatusName }}</span>
									</td>
									<td>{{ order.designated === 1 ? 'Y' : 'N' }}</td>
									<td>{{ order.time_in | hideYear('MM-DD-YYYY HH:II:SS') }}</td>
									<td>{{ order.time_out | hideYear('MM-DD-YYYY HH:II:SS') }}</td>
									<td class="al_right">{{ order.display_duration }}</td>
									<td class="al_right">{{ order.box_qty | commaSeparated }}</td>
									<td class="al_right">{{ order.order_qty | commaSeparated }}</td>
									<td class="al_right">{{ order.work_qty | commaSeparated }}</td>
									<td v-if="!search_box_type" class="al_right">{{ order.wb_quantity | commaSeparated }}</td>
									<td v-if="jIndex === 0" :rowspan="el.order_list.length" class="al_right">{{ el.total_pcs | commaSeparated }}</td>
									<td v-if="jIndex === 0 && el.rowspanCnt" :rowspan="el.rowspanCnt" class="al_right">{{ el.sum_total_pcs | commaSeparated }}</td>
									<td v-if="jIndex === 0 && el.rowspanCnt" :rowspan="el.rowspanCnt" class="al_right">{{ el.avg_duration }}</td>
									<td v-if="jIndex === 0 && el.rowspanCnt" :rowspan="el.rowspanCnt" class="al_right">{{ el.avg_pcs_per_hour | toCurrency }}</td>
								</tr>
							</template>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import WarehouseWorking from '@/views/statistics/warehouseWorking/WarehouseWorking';
import PartnerSelect from '@/components/common/PartnerSelect';
// import AC from '@/components/common/AC';
import { apiSelectUserList } from '@/api/basicinfo/user';
import { apiPackingPerStaff } from '@/api/report/report';
import { apiPickingPrintDataList } from '@/api/sales/invoice.js';
import { apiSelectSample } from '@/api/sales/sample.js';
import { apiGetReportTemplate, Report, reportMrtUrl, companyMrtUrl, getMrtFile, objectToFormData, PrintType, reportRenderBase64 } from '@/api/util';
import { inputSelectOnClick, fixDecimalPlace } from '@/utils/etc.js';
import { today } from '@/utils/date.js';
import { apiSalesReturnReceipt } from '@/api/report/report';
export default {
	data: () => ({
		from_date: null,
		to_date: null,

		type: null, // All, Packer, Picker
		so_keyword: null,

		box_type: 'UNIT',
		box_type_list: [
			{ value: 'UNIT', display: 'Only Unit Box' },
			{ value: 'WHOLE', display: 'Only Whole Box' },
			{ value: null, display: 'ALL' },
		],

		wh_staff_id: null,
		wh_staff_list: [],

		ship_to_code: null,
		bill_to_code: null,
		// keyword: null,
		// acKey: 0,

		packing_per_staff_list: [],
		graph_datasets: [],
		agg_info: {},
		inv_info: {},
		chartKey: 0,
		isShowGraph: false,

		search_from_date: null,
		search_to_date: null,
		search_type: null,
		search_staff: null,
		search_so_keyword: null,
		search_box_type: null,

		graph_sort: null,
		is_graph_image: false,

		sort_key: null,
		sort_direction: null,
	}),
	components: {
		CustomDatePicker,
		WarehouseWorking,
		PartnerSelect,
		// AC,
	},
	props: {
		component_of_modal: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		session_user: {
			get() {
				return this.$session.get('user');
			},
		},
		isGraphInfo: {
			get() {
				return this.graph_datasets && this.graph_datasets.length;
			},
		},
		isPackingPerStaffInfo: {
			get() {
				return this.packing_per_staff_list && this.packing_per_staff_list.length;
			},
		},
	},
	methods: {
		reset() {
			this.from_date = today();
			this.to_date = today();
			this.wh_staff_id = null;
			this.type = null;
			this.so_keyword = null;
			this.box_type = 'UNIT';
			this.sort_key = null;
			this.sort_direction = null;
			this.ship_to_code = null;
			this.bill_to_code = null;
		},
		sortMark(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.getPackingPerStaff();
		},
		async printGraphImage(graphImage) {
			if (!graphImage) return;
			// console.log(JSON.stringify({ from_date: this.search_from_date, to_date: this.search_to_date, box_type: this.search_box_type, type: this.search_type, agg_info: this.agg_info, graph_image: graphImage }, null, 4));
			const data = { from_date: this.search_from_date, to_date: this.search_to_date, box_type: this.search_box_type, type: this.search_type, agg_info: this.agg_info, graph_image: graphImage };
			const reportTemplate = await apiGetReportTemplate('PackingPerStaffGraph', reportMrtUrl('PackingPerStaffGraph'));
			const report = new Report(reportTemplate, data, 'PackingPerStaffGraph', PrintType.Normal, false, false, null, 70);
			this.$store.commit('setReport', report);
			this.is_graph_image = false;
		},
		async printPicking(order) {
			if (order.status_code === 'X') {
				let sample_no = order.invoice_no;
				apiSelectSample({ sample_no })
					.then(xhr => {
						reportRenderBase64(xhr.data, 'SampleRequest', reportMrtUrl('SampleRequest'));
					})
					.catch(() => {
						this.$toast.error('An error has occurred.');
					});
			} else {
				let invoice_no = order.invoice_no;
				let { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: [invoice_no] }));
				if (data.result_code === 'success') {
					const reportTemplate = await getMrtFile(companyMrtUrl('Picking'));
					const report = new Report(reportTemplate, data.data, 'Picking', PrintType.List);
					this.$store.commit('setReport', report);
					return true;
				} else {
					this.$toast.error(data.errorSoList + ' An error has occurred.');
					return false;
				}
			}
		},
		goToBoxing(so_dn) {
			const routeData = this.$router.resolve({ name: 'boxing', query: { so_dn } });
			window.open(routeData.href, '_blank');
		},
		makeDataForReport() {
			let arrForReport = [];
			let prevUserId = null;
			let idx = 0;
			let idxById = 0;

			const makeObjectNPushArr = function(obj, el) {
				if (prevUserId !== el.user_id) {
					idxById++;
					prevUserId = el.user_id;
				}

				obj['idxById'] = idxById;
				obj['idx'] = idx;

				for (let prop in el) {
					if (prop !== 'order_list') obj[prop] = el[prop];
				}

				arrForReport.push(obj);
			};

			this.packing_per_staff_list.forEach(el => {
				if (Array.isArray(el.order_list)) {
					el.order_list.forEach((e, index) => {
						let obj = {};

						for (let prop in e) {
							// '시:분:초'로 화면에 출력
							if (['time_in', 'time_out'].some(p => p === prop)) {
								obj[prop] = e[prop].substring(0, 16);
							} else obj[prop] = e[prop];
						}

						makeObjectNPushArr(obj, el);
						if (index === el.order_list.length - 1) obj.drawHyphen = 'Y';
					});
				} else {
					makeObjectNPushArr({}, el);
				}

				idx++;
			});

			/*
			console.log(
				JSON.stringify({
					from_date: this.from_date,
					to_date: this.to_date,
					box_type: this.search_box_type,
					packing_per_staff_list: arrForReport,
				}),
			); */

			return arrForReport;
		},
		async reportPrint() {
			if (!this.packing_per_staff_list || this.packing_per_staff_list.length < 1) return this.$toast.error('No List To Be Shown');

			const data = { from_date: this.search_from_date, to_date: this.search_to_date, box_type: this.search_box_type, packing_per_staff_list: this.makeDataForReport() };
			const reportTemplate = await apiGetReportTemplate('PackingPerStaff', reportMrtUrl('PackingPerStaff'));
			const report = new Report(reportTemplate, data, 'PackingPerStaff', PrintType.Normal, false, false, null, 70);
			this.$store.commit('setReport', report);
		},
		clearAC() {
			this.wh_staff_id = null;
			this.keyword = null;
			this.$toast.error('noting selected');

			this.acKey++;
		},
		showGraph() {
			if (!this.isShowGraph && (!this.isGraphInfo || !this.isPackingPerStaffInfo)) return this.$toast.error('No Data for Graph');
			this.isShowGraph = !this.isShowGraph;
		},
		async getWhStaffList() {
			let { data } = await apiSelectUserList({
				company_id: this.session_user.company_id,
				active_yn: 'Y',
				user_type: 'whstaff',
				sort_key: 'user_name',
			});

			this.wh_staff_list = data.userList;
		},
		setNSortGraphDatasets(graphList) {
			if (this.graph_sort === 'TIME') {
				for (let i = 0; i < graphList.length; i++) {
					for (let j = i + 1; j < graphList.length; j++) {
						if (graphList[i].avg_pcs_per_hour < graphList[j].avg_pcs_per_hour) {
							let temp = graphList[i];
							graphList[i] = graphList[j];
							graphList[j] = temp;
						}
					}
				}
			} else {
				if (!this.graph_sort) this.graph_sort = 'QTY';

				for (let i = 0; i < graphList.length; i++) {
					for (let j = i + 1; j < graphList.length; j++) {
						if (graphList[i].sum_total_pcs < graphList[j].sum_total_pcs) {
							let temp = graphList[i];
							graphList[i] = graphList[j];
							graphList[j] = temp;
						}
					}
				}
			}

			this.graph_datasets = graphList;

			if (!this.isGraphInfo) this.$toast.error('No Data for Graph');
			else {
				this.isShowGraph = true;
				this.chartKey++;
			}
		},
		makeDisplayEl(whList, datasets) {
			// user_id로 행 그룹핑
			if (!(whList && whList.length)) return [];

			let i = 0;
			let isLastStaff = false;
			while (!isLastStaff) {
				let rowspanCnt = 0;
				isLastStaff = true;

				for (let j = i; j < whList.length; j++) {
					if (whList[i].user_id === whList[j].user_id) {
						if (whList[j].order_list) rowspanCnt += whList[j].order_list.length;
					} else {
						whList[i].rowspanCnt = rowspanCnt;
						isLastStaff = false;
						i = j;
						break;
					}
				}

				if (isLastStaff) whList[i].rowspanCnt = rowspanCnt;
			}
			whList.forEach(el => {
				// 화면 출력, Print를 용이하게 하기 위해 packing_per_staff_list 각 요소에 총 작업수량, 오더당 평균수량, 오더당 평균 작업시간 set
				if (Array.isArray(datasets)) {
					let idx = datasets.findIndex(ds => ds.user_id === el.user_id);
					if (idx > -1) {
						el.sum_total_pcs = datasets[idx].sum_total_pcs;
						el.avg_pcs_per_hour = datasets[idx].avg_pcs_per_hour;
						el.avg_duration = this.makeDisplayDuration(datasets[idx].avg_duration);
					}
				}

				if (el.order_list) {
					el.order_list.forEach(e => {
						e.display_duration = this.makeDisplayDuration(e.time_diff);

						let idx = this.$saleStatusCodes.findIndex(s => s.code === e.status_code);

						if (idx > -1) e.color_by_status = this.$colorListForChart[idx];
						else if (e.status_code === 'X') e.color_by_status = '#0080FF';
					});
				}
			});

			return whList;
		},
		makeDisplayDuration(time_diff) {
			if (!time_diff && time_diff !== 0) return '';

			let hour = Math.floor(time_diff / 60);
			let minute = time_diff % 60;
			return (hour > 0 ? hour + 'h ' : '') + (minute % 1 === 0 ? minute : fixDecimalPlace(minute, 2)) + 'm';
		},
		async getPackingPerStaff() {
			if (!(this.from_date && this.to_date) && !this.so_keyword) return this.$toast.error('Please Input period or SO/Invoice DN');

			this.search_from_date = this.from_date;
			this.search_to_date = this.to_date;
			this.search_staff = this.wh_staff_id;
			this.search_type = this.type;
			this.search_so_keyword = this.so_keyword || null;
			this.ship_to_code = this.ship_to_code || null;
			this.bill_to_code = this.bill_to_code || null;
			this.search_box_type = this.box_type;

			let { data } = await apiPackingPerStaff(
				this.search_from_date,
				this.search_to_date,
				this.search_staff,
				this.search_type,
				this.search_so_keyword,
				this.ship_to_code,
				this.bill_to_code,
				this.search_box_type,
				this.sort_key,
				this.sort_direction,
			);

			this.packing_per_staff_list = this.makeDisplayEl(data.packing_per_staff_list, data.graph_datasets);
			this.setNSortGraphDatasets(data.graph_datasets);
			this.agg_info = data.agg_info;

			this.selectSalesReturnReceipt(this.from_date, this.to_date);
		},
		async selectSalesReturnReceipt(from_date, to_date) {
			const paramObj = {
				from_date,
				to_date,
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiSalesReturnReceipt(param);
			this.inv_info = data.value;
		},
		async init() {
			this.reset();
			await this.getWhStaffList();
		},
	},
	async created() {
		if (!this.component_of_modal) {
			this.$store.commit('setSideIndex', 7);
			this.$store.commit('setSelectedMenu', 'nav_li_packing_per_staff');
			this.$store.commit('setSubTitle', 'Report -> Packing Per Staff');
		}

		await this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style scoped>
.list_tbl .normal_tbl td {
	background-color: white;
}

.list_tbl .normal_tbl td:last-child {
	border-right: 1px solid #dbdbdb;
}

.td_bold td {
	font-weight: bold;
	font-size: 15px;
}
</style>
